// Suggested values offered when an admin first populates a System Value list,
// both in the setup wizard and in the System Values module afterwards.
// Anything not listed is added through the "Add Other" field on the picker.

export const SERVICE_CATALOG = [
  "Translation",
  "Editing & Revision",
  "Proofreading",
  "MT Post-Editing (MTPE)",
  "Localization",
  "Transcreation",
  "Transcription",
  "Subtitling",
  "Interpretation",
  "Voice-Over",
  "Linguistic Quality Assurance (LQA)",
  "Linguistic Sign-Off (LSO)",
  "DTP",
];

export const UNIT_CATALOG = [
  "Word",
  "Character",
  "Hour",
  "Minute",
  "Page",
  "Other",
];

// admin_units.is_word marks the word-count unit, which drives CAT analysis.
export const buildUnitBody = (name) => ({
  name,
  active_flag: true,
  is_word: name.trim().toLowerCase() === "word",
});
